// Lấy bot token cho chế độ non-interactive từ cờ đã kiểm (`resolveCommFlagsOrThrow`).
//
// Dùng chung cho `avatar comm-connect` và nhánh comm của `avatar init` — hai site
// trước đây cùng đọc thẳng `preset.botToken`. Tách ra đây để nhánh
// `--comm-bot-token-from-server` (có lời gọi mạng) nằm SAU bước kiểm cờ hermetic,
// và để hai site không mỗi nơi tự viết một bản thông điệp lỗi.
import type { ResolvedCommFlags } from "./comm-setup-non-interactive-flags.js";
import { fetchBotTokenFromServer } from "./fetch-mattermost-bot-token-from-server.js";
import { maskBotToken } from "./mask-mattermost-bot-token.js";
import { log } from "./terminal-logger.js";

export const SERVER_TOKEN_UNAVAILABLE_MESSAGE =
  "Không lấy được bot token @avatar từ server NAL (chưa `avatar login`, phiên hết hạn, hoặc mất mạng). " +
  "Chạy `avatar login` rồi thử lại, hoặc truyền token qua --comm-bot-token-stdin.";

export async function resolvePresetCommBotToken(
  preset: ResolvedCommFlags,
  fetchFromServer: (botName: string) => Promise<string | null> = fetchBotTokenFromServer,
): Promise<string> {
  if (preset.tokenSource === "stdin") {
    return preset.botToken;
  }
  // Server fail-soft trả null ở mọi nhánh lỗi. Ở đây máy gọi đã CHỦ ĐỘNG khai
  // `--comm-bot-token-from-server` nên null phải thành lỗi rõ — rơi ngầm về cách
  // khác là dùng credential mà máy gọi không khai.
  const token = await fetchFromServer(preset.botName);
  if (!token) {
    throw new Error(SERVER_TOKEN_UNAVAILABLE_MESSAGE);
  }
  log.info(`Dùng bot token @avatar từ server NAL (${maskBotToken(token)}).`);
  return token;
}
